/**
 * Created by DRaco2 on 03.03.2017.
 */

export function localStorageSupport() {
  try {
    if ("localStorage" in window && window["localStorage"] !== null) {
      try {
        localStorage.setItem("test", "test");
        localStorage.removeItem("test");
        return true;
      } catch (e) {
        console.error("localStorage not supported/quota exceeded.", e);
        return false;
      }
    }
  } catch (err) {
    console.warn(err);
    return false;
  }
}

export function setItem(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  if (localStorageSupport()) {
    localStorage.setItem(name, value);
  } else {
    document.cookie = `${name}=${value}${expires}; path=/`;
  }
}
export function getItem(name) {
  if (localStorageSupport()) {
    let ret = localStorage.getItem(name);
    //console.log(typeof ret);
    switch (ret) {
      case "true":
        return true;
      case "false":
        return false;
      default:
        return ret;
    }
  } else {
    let nameEQ = `${name}=`;
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) == 0) {
        let ret = c.substring(nameEQ.length, c.length);
        switch (ret) {
          case "true":
            return true;
          case "false":
            return false;
          default:
            return ret;
        }
      }
    }
    return null;
  }
}

export function removeItem(name) {
  if (localStorageSupport()) {
    localStorage.removeItem(name);
  } else {
    setItem(name, "", -1);
  }
}



// WEBPACK FOOTER //
// ./src-cookie-manager/utils/local-storage-util.js